<template>
	<li class="nav-item dropdown">
		<a class="nav-link" data-toggle="dropdown" href="#">
			<img :src="flag" style="height: 20px;"/> 
			<span class="d-none d-md-inline-flex ml-1">
				{{ locale }} 
			</span>
			<fa :icon="fas.faAngleDown" class="ml-1"/>
		</a>
		<div class="dropdown-menu dropdown-menu-right">
			<a href="javascript:void(0);" class="dropdown-item" @click="changeLocale('kh')">
				<img src="/flag/kh.png" style="height: 20px;"/>
				ភាសាខ្មែរ
			</a>
			<a href="javascript:void(0);" class="dropdown-item" @click="changeLocale('en')">
				<img src="/flag/en.png" style="height: 20px;"/>
				English
			</a>
      <!--<a href="javascript:void(0);" class="dropdown-item" @click="changeLocale('vn')">
        <img src="/flag/vn.png" style="height: 20px;"/>
        Tiếng Việt
      </a>
      <a href="javascript:void(0);" class="dropdown-item" @click="changeLocale('th')">
        <img src="/flag/th.png" style="height: 20px;"/>
        ภาษาไทย
      </a>
      <a href="javascript:void(0);" class="dropdown-item" @click="changeLocale('la')">
        <img src="/flag/la.png" style="height: 20px;"/>
        ພາສາລາວ
      </a>
      <a href="javascript:void(0);" class="dropdown-item" @click="changeLocale('cn')">
        <img src="/flag/cn.png" style="height: 20px;"/>
        中文
      </a>-->
		</div>
	</li>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
	name: "DropdownLocaleChanger",
	data() {
		return {
			locale: "",
			flag: "",
		};
	},
	computed: {
		fas() {
			return fas;
		}
	},
	mounted() {
		const locale = this.$i18n.locale;
		this.updateLabelLocale(locale);
	},
	methods: {
		changeLocale(locale) {
			this.$i18n.locale = locale;
			localStorage.setItem("locale", locale);
			this.updateLabelLocale(locale);
			this.$validator.localize({
				[this.$i18n.locale]: locale
			});
			this.$root.$emit('languageChanged');
		},
		updateLabelLocale(locale) {
			this.flag = "/flag/" + locale + ".png";
			switch (locale) {
				case "kh":
					this.locale = "ភាសាខ្មែរ";
					break;
				case "en":
					this.locale = "English";
					break;
        case "vn":
          this.locale = "Tiếng Việt";
          break;
        case "th":
          this.locale = "ภาษาไทย";
          break;
        case "la":
          this.locale = "ພາສາລາວ";
          break;
        case "cn":
          this.locale = "中文";
          break;
			}
			return true;
		}
	}
};
</script>

<style scoped>
	.dropdown-item {
		font-size: 11pt;
	}
</style>
